import type { InsightObjectAttributeType } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-attribute-type.tsx';

export const isTextAreaAttribute = (attributeType: InsightObjectAttributeType): boolean =>
	attributeType.type === 'default' && attributeType.defaultType.name.toLowerCase() === 'textarea';

export const isMultiSelectAttribute = (attributeType: InsightObjectAttributeType): boolean =>
	attributeType.type !== 'default' && attributeType.maximumCardinality !== 1;
